import type { TFunction } from "@luckymenu/i18n";
import type { NavItem } from "@luckymenu/ui-web";
import {
	Bot,
	Building2,
	LayoutDashboard,
	ReceiptIndianRupee,
	ScrollText,
	ShieldCheck,
} from "lucide-react";

/** Admin sections from docs/product/ux-design.md. */
export function adminNav(t: TFunction<"nav">): NavItem[] {
	return [
		{ key: "dashboard", label: t("dashboard"), href: "/", icon: LayoutDashboard },
		{ key: "restaurants", label: t("restaurants"), href: "/restaurants", icon: Building2 },
		{ key: "billing", label: t("billing"), href: "/billing", icon: ReceiptIndianRupee },
		{ key: "ai-usage", label: t("aiUsage"), href: "/ai-usage", icon: Bot },
		{ key: "admins", label: t("admins"), href: "/admins", icon: ShieldCheck },
		{ key: "audit-log", label: t("auditLog"), href: "/audit-log", icon: ScrollText },
	];
}

export function activeKeyFor(pathname: string): string {
	const first = pathname.split("/")[1] ?? "";
	return first === "" ? "dashboard" : first;
}
